module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/newhome-89aefaee2dce16469b84c50fcd780a85.jpeg";